module.exports = __webpack_public_path__ + "img/icon-time02.425cd46f.png";